import dayjs from "dayjs";

import type { TimeframeRange } from "@/components/elements/TimeframeInput/types";

export function convertDateRange(range?: TimeframeRange) {
  if (range?.[0] && range?.[1]) {
    return { from: dayjs(range[0]).format(), to: dayjs(range[1]).format() };
  }
  return undefined;
}
